import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import PLPModule from '~/features/productList/PLPModule';
import { Modules, P40ProductListPage } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import { usePage } from '~/templates/pages/hooks/usePage';

type P40ProductListPageProps = P40ProductListPage;

export const PLPPage = (props: P40ProductListPageProps) => {
    const {
        pageElements,
        bottomPageElements,
        dataConfiguration,
        heroImage,
        heroImageAltText,
        categories,
        data,
        filterBottomContent,
        ...rest
    } = props;

    const { productListPageSize } = usePage();
    const { query } = useRouter();

    const renderBottomPageElements = useMemo(() => {
        if (!query.page) return bottomPageElements;

        return filterBottomContent ? null : bottomPageElements;
    }, [bottomPageElements, query, filterBottomContent]);

    return (
        <>
            <PLPModule
                hitsPerPage={productListPageSize}
                filters={dataConfiguration}
                image={heroImage}
                heroImageAltText={heroImageAltText}
                serverState={data?.plpResult ?? undefined}
                categories={categories?.filter((c) => c.link.title)}
                {...rest}
            >
                <DynamicBlockList elements={pageElements as Modules[]} />
            </PLPModule>
            <DynamicBlockList elements={renderBottomPageElements as Modules[]} />
        </>
    );
};
